<template>
  <div class="page-container">
    <el-row class="content-main">
      <el-col class="menu" :span="6">
        <router-link class="menu-title" :to="{path:'/usercenter'}">个人中心</router-link>
        <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" background-color="#F3F3F3" text-color="#666666" active-text-color="#666666">
          <el-menu-item v-for="item in userMenu" :disabled="item.disabled" :index="item.index" @click="golist(item.path)" :key="item.index">
            <i :class="item.iconClassess"></i>
            <span slot="title">{{item.name}}</span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="18">
        <div style="background-color:#fff">
          <router-view />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>

// import {
//   Usercenter
// } from "../../model/usercenter.js";
// let usercenter = new Usercenter();
export default {
  name: 'welcome',
  data() {
    return {
      userMenu: [
        { name: '我的订单', index: "1", path: { path: '/usercenter/order' }, iconClassess: 'el-icon-document' },
        { name: '买家保证金', index: "2", path: { path: '/usercenter/deposit' }, iconClassess: 'el-icon-bank-card' },
        { name: '出价记录', index: "3", path: { path: '/usercenter/history' }, iconClassess: 'el-icon-time' },
        { name: '收货地址', index: "4", path: { path: '/usercenter/address' }, iconClassess: 'el-icon-location-outline' },
      ],
      activeIndex: ""
    }
  },
  components: {

  },
  methods: {
    golist(path) {
      let _this = this;
      let routePath = _this.$route.path;
      if (routePath == path.path) return
      _this.$router.push(path)
    },
    checkRouterLocal(path) {
      let _this = this;
      // 查找当前路由下标高亮
      //findIndex返回传入一个测试条件（函数）符合条件的数组第一个元素位置。
      let index = _this.userMenu.findIndex(item => item.path.path === path);
      // console.log(index)
      _this.activeIndex = String(index + 1);
    },
  },
  created() {
    this.checkRouterLocal(this.$route.path)
  },
  watch: {
    "$route"() {
      let _this = this;
      console.log(_this.$route.path)
      // 获取当前路径
      let path = _this.$route.path;
      // 检索当前路径
      _this.checkRouterLocal(path);
    }
  }
}
</script>
<style lang="scss" scoped>
.content-main {
  margin-top: 20px;
  .menu {
    padding-right: 40px;
  }
  .menu-title {
    background: #cfa972;
    color: #fff;
    height: 56px;
    line-height: 56px;
    text-align: center;
    font-size: 15px;
    margin: 0;
    display: block;
  }
}
.el-menu-item.is-active {
  background-color: #fff !important;
  border-left: 2px solid #cfa972;
}
</style>